export default "__VITE_ASSET__C203jI8X__"